jQuery(document).ready(function ($) {
  $('.sf_title').on('click', function () {
    var shopify_accordion = $(this).closest('.sf_accordion');
    var shopify_content   = shopify_accordion.find('.sf_accordion_content');
    shopify_accordion.toggleClass('is_active');
    shopify_content.stop(true, true).slideToggle(300);

  });

});
